import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'auth-close-browser',
  templateUrl: './auth-close-browser.component.html',
  styleUrls: ['./auth-close-browser.component.scss', '../auth.common.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthCloseBrowserComponent {}
